export enum OptionsPrefixes {
	HIERARCHY_CALCULATION_PREFIX = 'hierarchy_calculation_',
}
